import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    liveEncoderAvailable: false,
    initializingLiveEncoder: false,
    liveJobsResultInfo: {},
    currentPage: 1,
    liveJobs: [],
    fetchingLiveJobs: false,
    liveJob: null,
    creatingLiveJob: false,
    gettingLiveJob: false,
    updatingLiveJob: false,
    gettingLiveJobTimings: false,
    resultInfo: {},
    liveJobTimings: [],
    timingsResultInfo: {},
    wizardActiveTab: null,
    gjBlob: null,
    fetchingLiveJobStatuses: false,
    liveJobStatuses: [],
    settingTranscodingStatus: false,
    cuttingLiveJobStatus: false,
    liveJobCuttedVideo: [],
    removingLiveJob: false,
  },
  getters: {
    currentPage: state => state.currentPage,
  },
  mutations: {
    SET_CUT_LIVE_JOB_STATUS(state, value) {
      state.cuttingLiveJobStatus = value
    },
    SET_FETCHING_LIVE_JOBS_STATUSES(state, value) {
      state.fetchingLiveJobStatuses = value
    },
    SET_LIVE_JOB_STATUSES(state, value) {
      state.liveJobStatuses = value
    },
    SET_INITIALIZING_LIVE_ENCODER(state, value) {
      state.initializingLiveEncoder = value
    },
    SET_LIVE_ENCODER_AVAILABLE(state, value) {
      state.liveEncoderAvailable = value
    },
    SET_LIVE_JOBS(state, res) {
      state.liveJobs = res.result
      state.liveJobsResultInfo = res.resultInfo
    },
    SET_LIVE_JOB(state, value) {
      state.liveJob = value
      state.liveJob.recordTypes = {
        RecordAllStream: 0,
        RecordHourlyStream: 1,
      }
    },
    SET_LIVE_JOB_CUTTED_VIDEO(state, value) {
      state.liveJobCuttedVideo = value
    },
    SET_TRANSCODING_STATUS(state, value) {
      state.settingTranscodingStatus = value
    },
    SET_FETCHING_LIVE_JOBS(state, value) {
      state.fetchingLiveJobs = value
    },
    SET_GETTING_LIVE_JOB(state, value) {
      state.gettingLiveJob = value
    },
    SET_CREATING_LIVE_JOB(state, value) {
      state.creatingLiveJob = value
    },
    SET_UPDATING_LIVE_JOB(state, value) {
      state.updatingLiveJob = value
    },
    SET_GETTING_LIVEJOB_TIMINGS(state, value) {
      state.gettingLiveJobTimings = value
    },
    SET_LIVE_JOB_TIMINGS(state, value) {
      state.liveJobTimings = value.result
      state.timingsResultInfo = value.resultInfo
    },
    SET_CURRENT_PAGE(state, value) {
      state.currentPage = value
    },
    SET_WIZARD_ACTIVE_TAB(state, value) {
      state.wizardActiveTab = value
    },
    SET_GJBLOB(state, value) {
      state.gjBlob = value
    },
    REMOVE_LIVE_JOB(state, id) {
      state.liveJobs = state.liveJobs.filter(h => h.name !== id)
    },
    SET_REMOVING_LIVE_JOB(state, value) {
      state.removingLiveJob = value
    },
  },
  actions: {
    initializeLiveEncoder({ commit }) {
      commit('SET_INITIALIZING_LIVE_ENCODER', true)
      commit('SET_LIVE_ENCODER_AVAILABLE', true)
      commit('SET_INITIALIZING_LIVE_ENCODER', false)
    },
    getLiveJob({ commit }, id) {
      commit('SET_GETTING_LIVE_JOB', true)
      return new Promise((resolve, reject) => {
        api('encoder')
          .get(`projects/${getProjectId()}/livejobs/${id}`)
          .then(response => {
            commit('SET_LIVE_JOB', response.data.result)
            resolve(response)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_GETTING_LIVE_JOB', false)
          })
      })
    },
    updateLiveJob({ commit }, query) {
      commit('SET_UPDATING_LIVE_JOB', true)
      return new Promise((resolve, reject) => {
        api('encoder')
          .put(`/projects/${getProjectId()}/livejobs/${query.name}`, query.liveJob)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_LIVE_JOB', false)
          })
      })
    },
    fetchLiveJobs({ commit }, payload) {
      const pageIndex = `pageIndex=${payload.pageIndex || 0}`
      const status = `status=${payload.status}`
      const search = `${payload.search ? `&search=${payload.search}` : ''}`
      const query = `?pageSize=10&${pageIndex}${search}&${status}`
      const livestreamProvider = payload.livestreamProvider ? `&livestreamProvider=${payload.livestreamProvider}` : ''
      const filters = query + livestreamProvider
      commit('SET_FETCHING_LIVE_JOBS', true)
      return new Promise((resolve, reject) => {
        api('encoder')
          .get(`projects/${getProjectId()}/livejobs${filters}`)
          .then(response => {
            commit('SET_LIVE_JOBS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_LIVE_JOBS', false)
          })
      })
    },
    fetchLiveJobsStatuses({ commit }) {
      commit('SET_FETCHING_LIVE_JOBS_STATUSES', true)
      return new Promise((resolve, reject) => {
        api('encoder')
          .get(`projects/${getProjectId()}/livejobs/statuses`)
          .then(response => {
            const statuses = response.data.jobStatusOptions
            statuses.sort((a, b) => a.id - b.id)
            commit('SET_LIVE_JOB_STATUSES', statuses)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_LIVE_JOBS_STATUSES', false)
          })
      })
    },
    getLiveJobTiming({ commit }, query) {
      const { jobId } = query
      const outputId = query.outputId ? `?outputId=${query.outputId}&` : ''
      const filters = `?${outputId}pageIndex=${query.pageIndex}&pageSize=${query.pageSize}`
      commit('SET_GETTING_LIVEJOB_TIMINGS', true)
      return new Promise((resolve, reject) => {
        api('encoder')
          .get(`projects/${getProjectId()}/livejobs/${jobId}/timings${filters}`)
          .then(response => {
            commit('SET_LIVE_JOB_TIMINGS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_LIVEJOB_TIMINGS', false)
          })
      })
    },
    cutLiveJob({ commit }, query) {
      const time = `?FromMilliseconds=${query.from}&ToMilliseconds=${query.to}`
      commit('SET_CUT_LIVE_JOB_STATUS', true)
      return new Promise((resolve, reject) => {
        api('encoder')
          .get(`projects/${getProjectId()}/livejobs/${query.id}/cut${time}`)
          .then(response => {
            commit('SET_LIVE_JOB_CUTTED_VIDEO', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_CUT_LIVE_JOB_STATUS', false)
          })
      })
    },
    removeLiveJob({ commit }, query) {
      commit('SET_REMOVING_LIVE_JOB', true)
      return new Promise((resolve, reject) => {
        api(`encoder${query.version}`)
          .delete(`/projects/${getProjectId()}/livejobs/${query.liveJobId}`)
          .then(response => {
            commit('REMOVE_LIVE_JOB', query.liveJobId)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_LIVE_JOB', false) })
      })
    },
    updateTranscoding({ commit }, query) {
      commit('SET_TRANSCODING_STATUS', true)
      return new Promise((resolve, reject) => {
        api(`encoder${query.version}`)
          .post(`/projects/${getProjectId()}/livejobs/${query.name}/toggle`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_TRANSCODING_STATUS', false)
          })
      })
    },

    // Live Jobs V2 API
    getLiveJobV2({ commit }, id) {
      commit('SET_GETTING_LIVE_JOB', true)
      return new Promise((resolve, reject) => {
        api('encoderV2')
          .get(`projects/${getProjectId()}/livejobs/${id}`)
          .then(response => {
            commit('SET_LIVE_JOB', response.data.result)
            resolve(response)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_GETTING_LIVE_JOB', false)
          })
      })
    },
    fetchLiveJobsV2({ commit }, payload) {
      const pageIndex = `pageIndex=${payload.pageIndex || 0}`
      const status = `status=${payload.status}`
      const search = `${payload.search ? `&search=${payload.search}` : ''}`
      const query = `?pageSize=10&${pageIndex}${search}&${status}`
      const livestreamProvider = payload.livestreamProvider ? `&livestreamProvider=${payload.livestreamProvider}` : ''
      const filters = query + livestreamProvider
      commit('SET_FETCHING_LIVE_JOBS', true)
      return new Promise((resolve, reject) => {
        api('encoderV2')
          .get(`projects/${getProjectId()}/livejobs${filters}`)
          .then(response => {
            commit('SET_LIVE_JOBS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_LIVE_JOBS', false)
          })
      })
    },
    createLiveJobV2({ commit }, job) {
      commit('SET_CREATING_LIVE_JOB', true)
      return new Promise((resolve, reject) => {
        api('encoderV2')
          .post(`projects/${getProjectId()}/livejobs`, job)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_CREATING_LIVE_JOB', false)
          })
      })
    },
    togglePullJobV2({ commit }, job) {
      commit('SET_GETTING_LIVE_JOB', true)
      return new Promise((resolve, reject) => {
        api('encoderV2')
          .post(`/projects/${getProjectId()}/livejobs/${job.name}/pull`, {})
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_LIVE_JOB', false)
          })
      })
    },
  },
}
